export default "__VITE_ASSET__BbYCBBdK__"